module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sl-mini-page",
    class: [_vm.themeClass],
    attrs: {
      "id": "app"
    }
  }, [_c('nprogress-container'), _vm._v(" "), _c('router-view'), _vm._v(" "), (_vm.$store.state.userAgent.isPhone && _vm.$store.state.user.userinfo !== null && _vm.versions === 'ios') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popWindow),
      expression: "popWindow"
    }],
    staticClass: "sl-download-app"
  }, [_c('b', {
    on: {
      "click": function($event) {
        _vm.popWindow = false
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _vm._m(0)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/app/ai-merchant/id1265743674"
    }
  }, [_vm._v("Please download the newest version APP")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-76c4819c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1121
// module chunks = 1